export interface ButtonOrderProps {
  confirm: React.ReactElement;
  dismiss: React.ReactElement;
}

const isWindows = window.navigator.userAgent.toLowerCase().includes("windows");

export const ButtonOrder: React.FC<ButtonOrderProps> = ({
  confirm,
  dismiss,
}) =>
  isWindows ? (
    <>
      {confirm}
      {dismiss}
    </>
  ) : (
    <>
      {dismiss}
      {confirm}
    </>
  );
